module.exports = __webpack_public_path__ + "static/step-2@2x-9efbe1298e6ddebc0930602a7f6508b7.webp";